import type TranscriptWord from './transcriptWord';

export default class SubtitleCue {
  words: TranscriptWord[] = [];
  private characterLength = 0;
  public addWord(word: TranscriptWord) {
    this.words.push(word);
    this.characterLength += word.content.length;
  }

  public getCharacterLength() {
    return this.characterLength;
  }
}
